var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 12H18.1406C17.7428 12 17.3613 12.158 17.08 12.4393C16.7987 12.7207 16.6406 13.1022 16.6406 13.5V17.25C16.6406 17.6478 16.7987 18.0294 17.08 18.3107C17.3613 18.592 17.7428 18.75 18.1406 18.75H19.6406C20.0384 18.75 20.42 18.592 20.7013 18.3107C20.9826 18.0294 21.1406 17.6478 21.1406 17.25V12ZM21.1406 12C21.1407 10.8118 20.9054 9.63529 20.4484 8.53844C19.9915 7.4416 19.3218 6.4461 18.4781 5.60938C17.6344 4.77267 16.6334 4.1113 15.5328 3.66344C14.4322 3.21559 13.2538 2.99011 12.0656 3.00001C10.8782 2.99135 9.70083 3.21775 8.60132 3.66616C7.5018 4.11458 6.50189 4.77614 5.6592 5.61273C4.81651 6.44932 4.1477 7.4444 3.69131 8.54063C3.23492 9.63686 2.99997 10.8126 3 12V17.25C3 17.6478 3.15804 18.0294 3.43934 18.3107C3.72064 18.592 4.10218 18.75 4.5 18.75H6C6.39782 18.75 6.77936 18.592 7.06066 18.3107C7.34196 18.0294 7.5 17.6478 7.5 17.25V13.5C7.5 13.1022 7.34196 12.7207 7.06066 12.4393C6.77936 12.158 6.39782 12 6 12H3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 17.25V19.5C21.1406 20.2956 20.8246 21.0587 20.2619 21.6213C19.6993 22.1839 18.9363 22.5 18.1406 22.5H12.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.fbd73dc3ac174743d1a4f79520fd622c.svg";
export { ForwardRef as ReactComponent };